<template>
 <div>
  <multiselect :show-labels="false" v-model="value" :options="options" @input="onChange" placeholder="Selecciona" label="text" track-by="text"></multiselect>
</div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import axios from "axios";
import config from '../../../helpers/config';

  export default {
    mounted() {
      this.getIndicators()
    },
    data () {
      return {
        value: [],
        options: []
      }
    },
    methods: {
      onChange(event){
          localStorage.setItem("indi_id", event.value)
      },
     getIndicators(){
        axios.get(`${config.urlApi}/indicators`, {})
          .then(response => {
              response.data.forEach(element => {
                this.options.push({
                  value: element.id,
                  text: element.type
                })
            });
        })
        .catch(function (error) {
         ////console.log(error)
        })
      },
    },
    components: {
      Multiselect
    }
  }
</script>
